import schema from 'schm';

const toastMessage = schema({
  message: '',
  open: false,
});

export default toastMessage;
